<template lang="html">
    <div class="moteurs">
        <top-nav></top-nav>

        <page-title :title="factory.name" icon="location"></page-title>

        <div class="actions-bar">
            <div class="container">
                <template v-if="displayReportButtons">
                  <div class="rapport-section">
                      <h2 class="rapport-title">{{ getText('motors_audit_report_title') }}</h2>
                      <ns-loader
                          ref="graph-loader"
                          class="ns-loader"
                          :toLoad="toLoad"
                          @dataFetched="onDataFetched"
                      >
                          <div slot="content">
                              <div class="actions">
                                  <el-button
                                      v-for="model in modelReports"
                                      v-if="userIsAtLeastAdmin || model.activate_cee !== true"
                                      :key="model.uid"
                                      type="text"
                                      class="greenButton"
                                      @click="redirectToReportView(model.name)"
                                  >{{ model.name }}</el-button>
                              </div>
                          </div>
                      </ns-loader>
                  </div>
                  <hr>
                </template>
                <el-row :gutter="24">
                    <el-col :span="8">
                        <div class="main-action-wrapper">
                            <router-link :to="{ name: 'moteur', params: { siteid: $route.params.siteid } }">
                                <el-button class="greenButton">{{getText('motors_add_button')}}</el-button>
                            </router-link>
                            <el-button
                                class="greenButton import-motor-button"
                                @click="openImportModal"
                            >
                                {{getText('motors_import_button')}}
                            </el-button>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="layout-display">
                            <span
                                @click="showGrid"
                                class="icon icon-layout-table"
                                :class="{ active: displayGrid }"
                            ></span>
                            <span
                                @click="showTable"
                                class="icon icon-layout-grid"
                                :class="{ active: !displayGrid }"
                            ></span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <el-input :placeholder="getText('motors_search_bar')" class="researchField" v-model="filter">
                        </el-input>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="viveco-footer-background">

            <div v-if="!displayGrid" class="cards-list">
                <div class="container">
                    <el-row :gutter="24">
                        <el-col
                            v-for="engine in filteredEngines"
                            :key="engine.uid"
                            :span="8"
                        >
                            <el-card class="card-1-cta card-engine">

                                <router-link class="edit-btn" :to="{ name: 'moteur', params: { siteid: $route.params.siteid, uid: engine.uid } }">
                                    <span class="icon-edit"></span>
                                </router-link>
                                <div class="archive-site-btn">
                                    <el-button
                                        class="button"
                                        @click="toggleArchiving(engine)"
                                        type="info"
                                        icon="el-icon-delete"
                                        circle
                                    ></el-button>
                                </div>

                                <div slot="header">
                                    <div class="title">{{engine.name}}</div>
                                </div>
                                <div>
                                    {{engine.comment}}
                                </div>
                                <div>
                                    <el-radio v-model="selected" :label="engine.uid" class="action-card-checkbox" @change="selectEngine(engine)">{{getText('motors_select')}}</el-radio>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <div v-else class="table">
                <table-component
                    :data="filteredEngines"
                    :show-filter="false"
                    :show-caption="false"
                    sort-by="name"
                    sort-order="asc"
                >
                    <table-column show="name" :label="getText('motors_tab_name')"></table-column>
                    <table-column show="comment" :label="getText('motors_tab_comment')"></table-column>
                    <table-column :sortable="false" :filterable="false" :label="getText('motors_tab_archive')">
                        <template slot-scope="row">
                            <div class="archive">
                                <el-button
                                    class="archive-button"
                                    @click="toggleArchiving(row)"
                                    type="info"
                                    icon="el-icon-delete"
                                    circle
                                ></el-button>
                            </div>
                        </template>
                    </table-column>
                    <table-column :sortable="false" :filterable="false" :label="getText('motors_tab_update')">
                        <template slot-scope="row">
                            <router-link :to="{ name: 'moteur', params: { siteid: $route.params.siteid, uid: row.uid } }" class="table-icon-link">
                                <span class="icon icon-edit"></span>
                            </router-link>
                        </template>
                    </table-column>

                    <table-column :sortable="false" :filterable="false" :label="getText('motors_tab_choose')">
                        <template slot-scope="row">
                            <el-radio v-model="selected" :label="row.uid" class="action-card-checkbox" @change="selectEngine(row)">{{getText('motors_select')}}</el-radio>
                        </template>
                    </table-column>
                </table-component>

            </div>

            <div class="container launch-simulation">
                <router-link :to="{ name: 'simulations', params: { uid: selectedMotor.uid} }">
                    <el-button v-if="selected != '0'" class="greenButton">{{getText('motors_simulation_button')}}</el-button>
                </router-link>
            </div>
            <el-dialog
                :title="getText('motors_archiving_title')"
                :visible.sync="archivingMotor"
                width="30%"
                @close="motorBeingArchived = {}"
            >
                <div>{{getText('motors_archiving_desc')}}</div>
                <span slot="footer">
                    <div class="dialogButtons">
                        <el-button
                            class="cancel whiteButton"
                            v-loading="dialogLoading"
                            @click="archivingMotor = false"
                        >{{getText('cancel_button')}}</el-button>
                        <el-button
                            v-loading="dialogLoading"
                            type="primary"
                            @click="archiveMotor"
                            class="save greenButton"
                        >{{getText('dialog_confirm_archive_button')}}</el-button>
                    </div>
                </span>
            </el-dialog>
            <el-dialog
                :title="getText('motors_import_modal_title')"
                :visible.sync="displayModal"
                class="import-motor-dialog"
                @close="closeImportModal"
            >
                <ImportMotorModal
                    @close="closeImportModal"
                ></ImportMotorModal>
            </el-dialog>
        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
import topNav from '../ui/top-nav.vue';
import pageTitle from '../ui/page-title.vue';
import pageFooter from '../ui/page-footer.vue';
import {mapGetters} from 'vuex';
import ImportMotorModal from './import-motor-modal/Index.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader.vue';
export default {
    data () {
        return {
            selected: '0',
            displayGrid: false,
            filter: '',
            selectedMotor: {},
            archivingMotor: false,
            dialogLoading: false,
            displayModal: false,
            motorBeingArchived: {},
            auditReports: [],
        };
    },
    computed: {
        ...mapGetters([
            'getText',
            'getFactoryEngines',
            'modelReports',
            'factoriesByUid',
            'userIsAtLeastAdmin',
        ]),
        toLoad() {
            return [
                {
                    name: 'auditReports',
                    model: 'auditReports',
                    filters: {
                        audit_uid: this.$route.params.siteid
                    }
                }
            ];
        },
        factoryEngines(){
            return this.getFactoryEngines(
                this.$route.params.siteid);
        },
        factory(){
            let factory = this.factoriesByUid(this.$route.params.siteid);
            if(factory){
                return factory;
            }
            return {
                name: 'loading'
            };
        },
        displayReportButtons(){
          return this.filteredEngines.length > 0;
        },
        filteredEngines() {
            let enginesNotArchived = this.factoryEngines.filter(engine => engine.archived === false)
            if (this.filter.length) {
                let filter = this.filter.toLowerCase();
                return this.orderMotors(enginesNotArchived.filter(item => {
                    let name = (item.name || '').toLowerCase();
                    return (name.includes(filter));
                }));
            } else {
                return this.orderMotors(enginesNotArchived);
            }
        }
    },
    methods: {
        onDataFetched(res) {
            this.$set(this, 'auditReports', res.auditReports);
        },
        openImportModal(){
            this.displayModal = true;
        },
        closeImportModal(){
            this.displayModal = false;
        },
        redirectToReportView(modelName) {
            let params = {
                modelName: modelName,
                auditId: this.$route.params.siteid
            }
            let report = this.auditReports.filter(report => report.audit_uid === this.$route.params.siteid).find(report => modelName === report.model_name)
            if (report !== undefined) {
                params.reportId = report.uid;
            }
            this.$router.push({
                name: 'report',
                params: params
            })
        },
        orderMotors(motorArray) {
            if (!motorArray.length)
                return motorArray;
            let index = 0;
            let tmp = {};
            while (index < motorArray.length) {
                if (index + 1 < motorArray.length) {
                    if (motorArray[index].creation_date.localeCompare(motorArray[index + 1].creation_date) == -1) {
                        tmp = JSON.parse(JSON.stringify(motorArray[index]));
                        motorArray[index] = JSON.parse(JSON.stringify(motorArray[index + 1]));
                        motorArray[index + 1] = JSON.parse(JSON.stringify(tmp));
                        index = -1;
                    }
                }
                index++;
            }
            return JSON.parse(JSON.stringify(motorArray));

        },
        selectMotorText() {
            return this.getText('motors_select');
        },
        showGrid() {
            this.displayGrid = true;
        },
        showTable() {
            this.displayGrid = false;
        },
        selectEngine(engine) {
            this.selectedMotor = engine;
        },
        toggleArchiving(motor) {
            this.archivingMotor = true;
            this.motorBeingArchived = motor;
        },
        archiveMotor() {
            this.dialogLoading = true;
            this.$store.dispatch('patchItem', {
                item: {
                    url: this.motorBeingArchived.url,
                    archived: true,
                },
                model: 'factoryEngines'
            }).then(() => {
                this.$notify.success({
                    message: this.getText('notify_engine_delete_successful'),
                });
                this.archivingMotor = false;
                this.motorBeingArchived = {};
            }).catch((error) => {
                this.$notify.error({
                    message: this.getText('notify_engine_delete_failed'),
                });
                console.error(error);
            }).finally(() => {
                this.dialogLoading = false;
            });
        }
    },
    components: {
        topNav,
        pageTitle,
        pageFooter,
        NsLoader,
        ImportMotorModal,
    },
};
</script>


<style lang="less">
@import '../../less/variables';

.moteurs {
    .actions-bar {
        padding-bottom: 30px;
        .rapport-section {
            margin-bottom: 30px;
            .ns-vue-loader {
                .el-card, .el-card__body {
                    border: none;
                    min-height: 70px;
                }
            }

            .rapport-title {
                text-align: left;
                text-transform: capitalize;
                color: #303133;
            }
            .el-button {
                height: 43px;
            }
            .actions {
                display: flex;
                .report-buttons {
                    display: flex;
                    align-items: center;
                    margin-right: 30px;
                    .report-button-label {
                        margin-right: 20px;
                        font-size: 16px;
                    }
                }

                .el-button-group {
                    border-radius: 4px;
                    margin-bottom: 10px;
                    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 5px 0px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 3px 1px -2px !important;
                    .el-button {
                        border: none !important;
                        background: #c4d600 !important;
                        color: white !important;
                        text-transform: uppercase !important;
                        font-size: 18px !important;
                        font-family: worksans, Arial, "Helvetica Neue", Helvetica, sans-serif !important;
                        +.el-button {
                            border-left: 1px solid #dcdfe6 !important;
                        }
                    }
                }



                .downloads {
                    margin-right: 50px;
                    display: flex;
                    flex-wrap: wrap;
                    .greenButton {
                        display: flex;
                        align-items: center;
                        &.disabled {
                            box-shadow: none;
                            color: #929395 !important;
                            background-color: #E6E6E7 !important;
                            cursor: not-allowed;
                        }
                    }
                }
            }
        }
    }
    .card-engine {
        .action-card-checkbox {
            width: 100%;
            text-align: center;
            margin-top: 40px;
        }
  }
    .table table {
        width: 100%;
        text-align: center;
        .archive {
            text-align: center;
            margin-top: 0;
            .archive-button {
                width: 30px;
                background-color: #CCCCCC;
                border: none;
                padding: 7px 6px 7px 7px;
                &:hover {
                    background-color: @color-1 !important;
                }
            }
        }

    }
    .launch-simulation {
        padding-top: 10px;
        text-align: center;
    }
}

.el-checkbox__input.is-checked+.el-checkbox__label {
    color: @color-1 ;
}

.el-checkbox__input.is-checked  .el-checkbox__inner {
    background-color: @color-1 ;
    border-color: @color-1 ;
}

.title {
    font-size: 20px;
}

.table-component__table__body {
    label {
        margin-top: 0;
        .el-checkbox__inner:hover {
            border-color: @color-1 !important;
        }
    }
}
.el-radio__inner:hover {
    border-color: @color-1 !important;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: @color-1 !important;
}
.el-radio__input.is-checked+.el-radio__label {
    color: @color-1;
}
.el-radio__input.is-checked .el-radio__inner {
    background: @color-1;
    border-color: @color-1;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: 0 0 2px 2px @color-1;
}
.main-action-wrapper{
    .import-motor-button{
        margin-top: 2rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/moteurs.vue